// Only code specific to this site should be here. Anything that can be used across multiple sites
// should be pushed into the KMS.
// const bootstrap = window.bootstrap;
import GLightbox from "glightbox";
import Splide from "@splidejs/splide";
import { ProportionalImageNormalisation } from "./proportional-image-normalisation.js";
import Masonry from "masonry-layout";
import {FloatLabels} from "@keodesign/float-labels";
	


export function init() {
	// setupTestimonialSlider();
	// setupBlockSlider();
	ProportionalImageNormalisation(".scale-me", 150, 0.525);
	// setupMasonry();
	// setupLightbox();
	// scrollAnimation();
	setupAutoHideMenu();
	new FloatLabels(".js-float-wrap");
}

export function isElementScrolledPast(el) {
	const rect = el.getBoundingClientRect();
	return rect.bottom < 0;
}


export function setupAutoHideMenu(){
	let lastScrollTop = 0;
	const menu = document.querySelector("#header-wrap");
	const splash_section = document.querySelector("#splash-wrap");
	menu.style.top = "0px";
	// const toggler = splash_section.querySelector(".navbar-toggler-icon");
	// const logo_mobile = splash_section.querySelector("#logo-mobile");
	window.addEventListener("scroll", () => {

		let scrollTop = window.scrollY || document.documentElement.scrollTop;
		if (isElementScrolledPast(splash_section)){
			if (scrollTop > lastScrollTop) {
			// Scrolling down
				menu.style.top = "-200px"; // Hide menu
			} else {
			// Scrolling up
				menu.style.top = "0px";
			}
			lastScrollTop = scrollTop;

		}
		
		
	});
}

export function setupLightbox(){
	GLightbox({
		plyr: {

			config: {
				ratio: "16:9", // or '4:3'
				muted: false,
				hideControls: true,
				youtube: {
					noCookie: true,
					rel: 0,
					showinfo: 0,
					iv_load_policy: 3
				},
				vimeo: {
					byline: false,
					portrait: false,
					title: true,
					speed: true,
					transparent: false
				}
			}
		}
	});

}


export function scrollAnimation() {
	const observer = new IntersectionObserver((entries) => {
		let delay = 0; // default delay for elements without reset-fade class
		entries.forEach(entry => {
			const el = entry.target;

			if (entry.isIntersecting) {
				if (el.classList.contains("reset-fade")){
					delay = 0; // reset delay for elements with reset-fade class
				}
				else
				{
					delay = delay + 200; // 100ms between each element
				}
				el.style.transitionDelay = `${delay}ms`;
				entry.target.classList.add("visible");
				observer.unobserve(el);

			}
			// else{
			// 	el.style.transitionDelay = "0ms"; // reset delay

			// 	entry.target.classList.remove("visible");
			// }
		});
	}, {
		threshold: 0.75 // You can tweak this for sensitivity
	});

	document.querySelectorAll(".fade-in-element").forEach(el => {
		observer.observe(el);
	});
}


export function setupMasonry(){
	var elem = document.querySelector(".masonry-layout");
	if(elem){
		new Masonry( elem, {
			itemSelector: ".item",
			// columnWidth: ".grid-sizer",
			percentPosition: true
	
		});
	}
}

export function setupBlockSlider(){
	var testimonialSlider = document.querySelectorAll(".block-slider");
	
	if(testimonialSlider){
		for (var i = 0; i < testimonialSlider.length; i++ ) {
			var slider = testimonialSlider[i].querySelector(".slider");
			
			new Splide( slider, {
				type   : "slide",
				rewind    : true,
				pagination: true,
				arrows    : false,
				autoplay: true,
			}).mount();
		}
	}
}


export function setupTestimonialSlider(){
	var testimonialSlider = document.querySelectorAll(".testimonial-slider");
	
	if(testimonialSlider){
		for (var i = 0; i < testimonialSlider.length; i++ ) {
			var slider = testimonialSlider[i].querySelector(".slider");
			
			new Splide( slider, {
				type   : "slide",
				rewind    : true,
				pagination: true,
				arrows    : false,
				autoplay: true,
			}).mount();
		}
	}
}


window.addEventListener("DOMContentLoaded", init);